var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bulletin-container" },
    [
      _c(
        "el-button",
        {
          staticStyle: { "margin-bottom": "15px" },
          attrs: { type: "primary", size: "mini", icon: "el-icon-plus" },
          on: { click: _vm.handleAddBulletin },
        },
        [_vm._v(" 新增公告 ")]
      ),
      _c("el-tag", { attrs: { type: "success" } }, [
        _vm._v(" 圖片須為.jpg,.png,.bmp格式，限制不超過200MB"),
      ]),
      _c(
        "el-table",
        {
          attrs: {
            size: "mini",
            data: _vm.bulletinList,
            border: "",
            fit: "",
            "highlight-current-row": "",
          },
        },
        [
          _c("el-table-column", {
            attrs: { align: "center", label: "編號", width: "70" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.id))])]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "left",
              label: "建立時間",
              prop: "content",
              width: "150",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-tag", { attrs: { size: "mini" } }, [
                      _vm._v(_vm._s(scope.row.buildDate)),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "left",
              label: "內容",
              prop: "content",
              "min-width": "50",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-input", {
                      attrs: { type: "textarea", rows: 6, size: "mini" },
                      model: {
                        value: scope.row.bulletinBoard,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "bulletinBoard", $$v)
                        },
                        expression: "scope.row.bulletinBoard",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: "附件", width: "500" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("UploadCustom", {
                      ref: "uploadBoardRef_" + scope.$index,
                      attrs: {
                        span: 24,
                        btnStyle: "primary",
                        accept: ".jpg,.jpeg,.bmp,.png",
                        payload: _vm.boardFileModel,
                        "data-obj": _vm.fileObj,
                        "limit-file-count": 50,
                        limitText: "",
                        "use-drag": false,
                        action: "TravelSettings/bulletinBoard",
                        "auto-upload": false,
                        "show-file-list": true,
                        "form-on-loading-parent": _vm.formLoading,
                        "btn-txt": "選擇檔案",
                        "before-file-list": _vm.getBeforeFileList(scope.row),
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: "操作", width: "300" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          size: "mini",
                          type: "success",
                          icon: "el-icon-check",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleSave(scope.row, scope.$index)
                          },
                        },
                      },
                      [_vm._v(" 保存 ")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          size: "mini",
                          type: "danger",
                          icon: "el-icon-delete",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleDelete(scope.row, scope.$index)
                          },
                        },
                      },
                      [_vm._v(" 刪除 ")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }